import { IonApp, IonPage, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route } from "react-router";
import Tables from "./pages/Tables";
import Login from "./pages/Login";
import "../src/App.css";
import { PrivateRoute } from "./PrivateRoute";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useAsyncEffect } from "./hooks/useAsyncEffect";
import { GetDevice, GetStatusDevice } from "./api";
import { setStatuses } from "./store/actions";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
// import "./theme/variables.css";

setupIonicReact(); // Эта строка ОБЯЗАТЕЛЬНА!

function App() {
  const token = useSelector((state) => state.token);
  const info = useSelector((state) => state.info);
  const dispatch = useDispatch();

  useEffect(() => {
    GetStatusDevice(token, info).then((e) => {
      dispatch(setStatuses(e.data.data.tests));
    });
  }, [token]);

  return (
    <IonApp>
      <IonPage>
        <IonReactRouter>
          <Route path="/login" component={Login} />
          <PrivateRoute path="/tables" component={Tables} />
          <Route exact path="/">
            <Redirect to="/login" />
          </Route>
          {token ? <Redirect to="/tables" /> : <Redirect to="/login" />}
        </IonReactRouter>
      </IonPage>
    </IonApp>
  );
}

export default App;
